import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(utc);
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(timezone);
dayjs.extend(quarterOfYear);

export function getFilterDatePresets() {
  return [
    { value: 'last30days', label: 'ostatnie 30 dni' },
    { value: 'thisMonth', label: 'aktualny miesiąc' },
    { value: 'lastMonth', label: 'poprzedni miesiąc' },
    { value: '12months', label: '12 miesięcy' },
    { value: 'thisYear', label: 'aktualny rok' },
    { value: 'lastYear', label: 'poprzedni rok' },
    { value: 'thisQuarter', label: 'aktualny kwartał' },
    { value: 'lastQuarter', label: 'poprzedni kwartał' },
    { value: 'custom', label: 'dowolny' },
  ];
}

export function getFromToFilterBasedOnPreset(preset) {
  const today = dayjs().utc(true);
  switch (preset.value) {
    case '12months': {
      return { fromDate: today.subtract(12, 'month'), toDate: today };
    }
    case 'thisMonth': {
      return { fromDate: today.startOf('month'), toDate: today.endOf('month') };
    }
    case 'last30days': {
      return { fromDate: today.subtract(30, 'day'), toDate: today };
    }
    case 'lastMonth': {
      return {
        fromDate: today.subtract(1, 'month').startOf('month'),
        toDate: today.subtract(1, 'month').endOf('month'),
      };
    }
    case 'thisYear': {
      return { fromDate: today.startOf('year'), toDate: today.endOf('year') };
    }
    case 'lastYear': {
      return { fromDate: today.subtract(1, 'year').startOf('year'), toDate: today.subtract(1, 'year').endOf('year') };
    }
    case 'thisQuarter': {
      return { fromDate: today.startOf('quarter'), toDate: today.endOf('quarter') };
    }
    case 'lastQuarter': {
      return {
        fromDate: today.subtract(1, 'quarter').startOf('quarter'),
        toDate: today.subtract(1, 'quarter').endOf('quarter'),
      };
    }
    case 'custom': {
      return { fromDate: today.subtract(5, 'year').startOf('year'), toDate: today.endOf('year') };
    }
    default: {
    }
  }
}
